import Sitemap from './sitemap';
import NotFound from './not-found';
import MyAccount from './my-account';
import Login from './login';
import CancelPasswordReset from './cancel-password-reset';
import ChangePassword from './change-password';
import ForgotPassword from './forgot-password';
import ResetPassword from './reset-password';
import Directory from './directory';

import Attendance from './attendance';
import Evacuation from './evacuation';
import EvacuationDemo from './evacuation-demo';

import LiveView from './live-view';
import LiveEvacuation from './live-evacuation';
import FaceLiveView from './face-live-view';
import Operators from './operators';
import SiteManager from './site-manager';
import Navigation from './navigation';
import Client from './client';
import ClientConfig from './client-config';
import Site from './site';
import Agent from './agent';
import Zone from './zone';
import Reader from './reader';
import Antenna from './antenna';
import Camera from './camera';
import Profile from './profile';
import Detectable from './detectable';
import Summary from './summary';
import RealtimeView from './realtime-view';
import FaceVisits from './face-visits';

import ClientRegistry from './client-registry';

import Reports from './reports';
import Qlikdashboard from './qlikdashboard';
import Qlikvisitorquery from './qlikvisitorquery';
import Qlikcompanyquery from './qlikcompanyquery';
import Qlikvisitorlist from './qlikvisitorlist';
import Qlikmap from './qlikmap';
import Qlikvisitanalysis from './qlikvisitanalysis';
import Qliksaascharges from './qliksaascharges';
import QlikClarendondashboard from './qlik-reports/clarendon/dashboard';
import QlikClarendonvisitorquery from './qlik-reports/clarendon/visitorquery';
import QlikClarendonvisitorlist from './qlik-reports/clarendon/visitorlist';
import QlikClarendoncompanyquery from './qlik-reports/clarendon/companyquery';
import QlikClarendonmap from './qlik-reports/clarendon/map';
import QlikClarendonvisitanalysis from './qlik-reports/clarendon/visitanalysis';
import QlikGrouchodashboard from './qlik-reports/groucho/dashboard';
import QlikGrouchovisitorquery from './qlik-reports/groucho/visitorquery';
import QlikGrouchovisitorlist from './qlik-reports/groucho/visitorlist';
import QlikGrouchosaascharges from './qlik-reports/groucho/saascharges';
import QlikGrouchomap from './qlik-reports/groucho/map';
import QlikGrouchovisitanalysis from './qlik-reports/groucho/visitanalysis';
import QlikTsbdashboard from './qlik-reports/tsb/dashboard';
import QlikTsbvisitorquery from './qlik-reports/tsb/visitorquery';
import QlikTsbvisitorlist from './qlik-reports/tsb/visitorlist';
import QlikTsbfunctionquery from './qlik-reports/tsb/functionquery';
import QlikTsbmap from './qlik-reports/tsb/map';
import QlikTsbvisitanalysis from './qlik-reports/tsb/visitanalysis';
import QlikTasudashboard from './qlik-reports/tasu/dashboard';
import QlikTasucompanyquery from './qlik-reports/tasu/companyquery';
import QlikTasuvisitorquery from './qlik-reports/tasu/visitorquery';
import QlikTasuvisitorlist from './qlik-reports/tasu/visitorlist';
import QlikTasusaascharges from './qlik-reports/tasu/saascharges';
import QlikTasumap from './qlik-reports/tasu/map';
import QlikTasuvisitanalysis from './qlik-reports/tasu/visitanalysis';
import Qlik25epcameracounting from './qlik-reports/25ep/cameracounting';
import Qlik25epdashboard from './qlik-reports/25ep/dashboard';
import Qlik25epvisitorquery from './qlik-reports/25ep/visitorquery';
import Qlik25epvisitorlist from './qlik-reports/25ep/visitorlist';
import Qlik25epfunctionquery from './qlik-reports/25ep/functionquery';
import Qlik25epmap from './qlik-reports/25ep/map';
import Qlik25epvisitanalysis from './qlik-reports/25ep/visitanalysis';

import QlikTsbMagnoxdashboard from './qlik-reports/tsbmagnox/dashboard';
import QlikTsbMagnoxvisitorquery from './qlik-reports/tsbmagnox/visitorquery';
import QlikTsbMagnoxvisitorlist from './qlik-reports/tsbmagnox/visitorlist';
import QlikTsbMagnoxmap from './qlik-reports/tsbmagnox/map';
import QlikTsbMagnoxvisitanalysis from './qlik-reports/tsbmagnox/visitanalysis';
import QlikTsbGreshamdashboard from './qlik-reports/tsbgresham/dashboard';
import QlikTsbGreshamvisitorquery from './qlik-reports/tsbgresham/visitorquery';
import QlikTsbGreshamvisitorlist from './qlik-reports/tsbgresham/visitorlist';
import QlikTsbGreshamfunctionquery from './qlik-reports/tsbgresham/functionquery';
import QlikTsbGreshammap from './qlik-reports/tsbgresham/map';
import QlikTsbGreshamvisitanalysis from './qlik-reports/tsbgresham/visitanalysis';
import QlikTsbKeypointdashboard from './qlik-reports/tsbkeypoint/dashboard';
import QlikTsbKeypointvisitorquery from './qlik-reports/tsbkeypoint/visitorquery';
import QlikTsbKeypointvisitorlist from './qlik-reports/tsbkeypoint/visitorlist';
import QlikTsbKeypointfunctionquery from './qlik-reports/tsbkeypoint/functionquery';
import QlikTsbKeypointmap from './qlik-reports/tsbkeypoint/map';
import QlikTsbKeypointvisitanalysis from './qlik-reports/tsbkeypoint/visitanalysis';

import QlikGleneaglesdashboard from './qlik-reports/gleneagles/dashboard';
import QlikGleneaglescompanyquery from './qlik-reports/gleneagles/companyquery';
import QlikGleneaglesvisitorquery from './qlik-reports/gleneagles/visitorquery';
import QlikGleneaglesvisitorlist from './qlik-reports/gleneagles/visitorlist';
import QlikGleneaglesmap from './qlik-reports/gleneagles/map';
import QlikGleneaglesvisitanalysis from './qlik-reports/gleneagles/visitanalysis';

import MfaSettings from './mfa-settings';

export { default as Notifications } from './notifications';
export { default as Imports } from './imports';

export {
	Sitemap,
	NotFound,
	MyAccount,
	Login,
	CancelPasswordReset,
	ChangePassword,
	ForgotPassword,
	ResetPassword,
	Directory,
	Attendance,
	Evacuation,
	EvacuationDemo,
	LiveView,
	LiveEvacuation,
	FaceLiveView,
	Operators,
	SiteManager,
	Navigation,
	ClientRegistry,
	Reports,
	Qlikdashboard,
	Qlikvisitorquery,
	Qlikcompanyquery,
	Qlikvisitorlist,
	Qlikmap,
	Qlikvisitanalysis,
	Qliksaascharges,
	Client,
	ClientConfig,
	Site,
	Summary,
	Agent,
	Zone,
	Reader,
	Antenna,
	Camera,
	Profile,
	Detectable,
	QlikClarendondashboard,
	QlikClarendonvisitorquery,
	QlikClarendonvisitorlist,
	QlikClarendoncompanyquery,
	QlikClarendonmap,
	QlikClarendonvisitanalysis,
	RealtimeView,
	FaceVisits,
	QlikGrouchodashboard,
	QlikGrouchovisitorquery,
	QlikGrouchovisitorlist,
	QlikGrouchosaascharges,
	QlikGrouchomap,
	QlikGrouchovisitanalysis,
	QlikTsbdashboard,
	QlikTsbvisitorquery,
	QlikTsbvisitorlist,
	QlikTsbfunctionquery,
	QlikTsbmap,
	QlikTsbvisitanalysis,
	QlikTasudashboard,
	QlikTasucompanyquery,
	QlikTasuvisitorquery,
	QlikTasuvisitorlist,
	QlikTasusaascharges,
	QlikTasumap,
	QlikTasuvisitanalysis,
	Qlik25epcameracounting,
	Qlik25epdashboard,
	Qlik25epvisitorquery,
	Qlik25epvisitorlist,
	Qlik25epfunctionquery,
	Qlik25epmap,
	Qlik25epvisitanalysis,
	QlikTsbMagnoxdashboard,
	QlikTsbMagnoxvisitorquery,
	QlikTsbMagnoxvisitorlist,
	QlikTsbMagnoxmap,
	QlikTsbMagnoxvisitanalysis,
	QlikTsbGreshamdashboard,
	QlikTsbGreshamvisitorquery,
	QlikTsbGreshamvisitorlist,
	QlikTsbGreshamfunctionquery,
	QlikTsbGreshammap,
	QlikTsbGreshamvisitanalysis,
	QlikTsbKeypointdashboard,
	QlikTsbKeypointvisitorquery,
	QlikTsbKeypointvisitorlist,
	QlikTsbKeypointfunctionquery,
	QlikTsbKeypointmap,
	QlikTsbKeypointvisitanalysis,
	QlikGleneaglesdashboard,
	QlikGleneaglescompanyquery,
	QlikGleneaglesvisitorlist,
	QlikGleneaglesvisitorquery,
	QlikGleneaglesmap,
	QlikGleneaglesvisitanalysis,
	MfaSettings,
};



// WEBPACK FOOTER //
// ./src/pages/index.js